export default "__VITE_ASSET__B4b4rN8t__"